import React, { useRef, useState } from "react";
import {
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    FormHelperText,
} from "@mui/material";
import { BsEye, BsEyeSlash } from "react-icons/bs";

const PasswordField = ({
                           register,
                           errors,
                           fieldName = "password",
                           label = "Password",
                           validation = {},
                           fullWidth = true,
                           required = true,
                       }) => {
    const [showPassword, setShowPassword] = useState(false);
    const inputElRef = useRef(null);

    const { ref, ...reg } = register(fieldName, {
        required: required ? `${label} is required` : false,
        ...validation,
    });

    const handleClickShowPassword = () => {
        const el = inputElRef.current;
        const start = el?.selectionStart ?? null;
        const end = el?.selectionEnd ?? null;

        setShowPassword((s) => !s);

        requestAnimationFrame(() => {
            const e = inputElRef.current;
            if (!e) return;
            e.focus({ preventScroll: true });
            if (start !== null && end !== null) e.setSelectionRange(start, end);
        });
    };

    const errorText = errors?.[fieldName]?.message;

    return (
        <FormControl fullWidth={fullWidth} error={!!errors[fieldName]} variant="outlined">
            <InputLabel htmlFor={fieldName}>{label}</InputLabel>
            <OutlinedInput
                id={fieldName}
                label={label}
                type={showPassword ? "text" : "password"}
                {...reg}
                inputRef={(el) => {
                    ref(el);
                    inputElRef.current = el;
                }}
                endAdornment={
                    <InputAdornment position="end" sx={{ alignItems: "center" }}>
                        <IconButton
                            aria-label={`toggle ${label.toLowerCase()} visibility`}
                            onClick={handleClickShowPassword}
                            edge="end"
                            tabIndex={-1}
                            onMouseDown={(e) => e.preventDefault()}
                        >
                            {showPassword ? <BsEyeSlash /> : <BsEye />}
                        </IconButton>
                    </InputAdornment>
                }
            />
            <FormHelperText>{errorText || " "}</FormHelperText>
        </FormControl>
    );
};

export default PasswordField;
